import type { CalendarDesign, CalendarLayout } from "#internal"

import { CalendarCoverAreas } from "../CalendarCoverAreas"
import { CalendarMonthAreas } from "../CalendarMonthAreas"
import { CalendarYearAreas } from "../CalendarYearAreas"

/** The designs for a calendar of any size, as its layout counts its pages:
 * a month a page under its picture, a month facing its picture, the year on
 * a page; each with the cover of a band of paper under a picture. */
export const GenericDesigns: Record<Exclude<CalendarLayout, "pad" | "week">, CalendarDesign> = {
  month: {
    cover: CalendarCoverAreas,
    page: (boxes, month) => CalendarMonthAreas(boxes, month, true),
    pages: "month",
  },
  spread: {
    cover: CalendarCoverAreas,
    page: (boxes, month) => CalendarMonthAreas(boxes, month, false),
    pages: "spread",
  },
  year: { cover: CalendarCoverAreas, page: CalendarYearAreas, pages: "year" },
}
